import { Appointment } from "features/appointment/types";
import { Purchase } from "features/purchase/types";

export interface ReasonResponse {
	createdAt: string;
	message: string;
	sampleId: number;
}

export interface Collaborator {
	_id: string;
	customer: {
		id: number;
		fullName: string;
	};
	fullName: string;
	personalId: string;
	personalCardType: ID_TYPE;
	phoneNumber: string;
	email: string;
	status: string;
	createdAt: string;
	updatedAt: string;
	dob: number;
	province: {
		id: number;
		name: string;
	};
	district: {
		id: number;
		name: string;
	};
	ward: {
		id: number;
		name: string;
	};
	address: string;
	jobTitle: string;
	facebook: string;
	instagram: string;
	tiktok: string;
	twitter: string;
	taxId: string;
	bankName?: { id: number; name: string };
	bankId: number;
	bankAccount: string;
	bankAccountNumber: string;
	rejectReasons: ReasonResponse[];
	blockReasons: ReasonResponse[]
	updatedBy?: { id: number; fullName: string };
}

export interface DataUpdateColabborator {
	_id: string;
	fullName: string;
	personalId: string;
	personalCardType: ID_TYPE;
	phoneNumber: string;
	email: string;
	status: string;
	taxId: string;
	bankId: number;
	bankAccount: string;
	bankAccountNumber: string;
}

export interface CollaboratorFilter {
	fullName?: string;
	email?: string;
	phoneNumber?: string;
	status?: string;
	skip: number;
	take: number;
}

export interface CollaboratorSlice {
	total: number;
	list: Collaborator[];
	detail: Collaborator | null;
	appointments: Appointment[];
	purchases: Purchase[];
}

export interface CollaboratorAppoimentsQuery {
	skip: number;
	take: number;
	startDate: string | null;
	endDate: string | null;
	status: string | null;
}

export interface CollaboratorPurchasesQuery {
	skip: number;
	take: number;
	startDate: string | null;
	endDate: string | null;
	status: string | null;
}

export enum COLLABORATOR_STATUS {
	NEW = "new",
	REJECTED = "rejected",
	ENABLE = "enable",
	DISABLE = "disable",
	BLOCKED = "blocked",
}

export enum ID_TYPE {
	NATIONAL_ID = "national_id",
	PASSPORT = "passport",
	DRIVER_LICENSE = "drive_license",
}
